// extracted by mini-css-extract-plugin
export default {"main":"FixedNavigation_main__zxiBc","svg":"FixedNavigation_svg__GW0v8"};